import LeadsTableSection from './LeadsTableSection';

export default LeadsTableSection;
